export default {
  create: {
    actuality: {
      title: 'Publish a news item'
    },
    action: {
      button: 'Add an action'
    },
    category: {
      title: 'Add a resource category'
    },
    document: {
      title: 'Add a resource'
    },
    employee: {
      button: 'Add an employee',
      title: 'Add or edit a birthday'
    },
    event: {
      title: 'Add an event'
    },
    notice: {
      title: 'Add a notice'
    },
    sub_category: {
      title: 'Add a resource subcategory'
    }
  },
  delete: {
    actuality: {
      button: 'Yes, delete the news item',
      message: 'Are you sure you want to delete the news item :TITLE',
      popup: 'News item successfully deleted.',
      title: 'Delete a news item'
    },
    alert: {
      button: 'Delete the alert'
    },
    category: {
      button: 'Yes, delete the category',
      message: 'Are you sure you want to delete the category :TITLE',
      popup: 'Category successfully deleted.',
      title: 'Delete a resource category'
    },
    document: {
      button: 'Yes, delete the document',
      message: 'Are you sure you want to delete the document :TITLE',
      popup: 'Document successfully deleted.',
      title: 'Delete a document'
    },
    employee: {
      button: 'Yes, delete the employee',
      message: 'Are you sure you want to delete the employee :TITLE',
      popup: 'Employee successfully deleted.',
      title: 'Delete an employee'
    },
    event: {
      button: 'Yes, delete the event',
      message: 'Are you sure you want to delete the event :TITLE',
      popup: 'Event successfully deleted.',
      title: 'Delete an event'
    },
    noDelete: 'No, don\'t delete',
    notice: {
      button: 'Yes, delete the notice',
      message: 'Are you sure you want to delete the notice :TITLE',
      popup: 'Notice successfully deleted.',
      title: 'Delete a notice',
    },
    sub_category: {
      button: 'Yes, delete the subcategory',
      message: 'Are you sure you want to delete the subcategory :TITLE',
      popup: 'Subcategory successfully deleted.',
      title: 'Delete a resource subcategory'
    }
  },
  edit: {
    action: {
      title: 'Edit actions and quick links'
    },
    actuality: {
      title: 'Edit a news item'
    },
    alert: {
      delete: 'Delete the alert',
      title: 'Edit the alert'
    },
    category: {
      title: 'Edit a resource category'
    },
    document: {
      title: 'Edit a resource'
    },
    employee: {
      delete: 'Delete the employee',
      title: 'Add or edit a birthday'
    },
    event: {
      title: 'Edit an event'
    },
    notice: {
      title: 'Edit a notice'
    },
    sub_category: {
      title: 'Edit a resource subcategory'
    }
  },
  label: {
    actuality: {
      text: 'News text',
      theme: 'News theme',
      title: 'News title'
    },
    birthday_day: 'Birthday',
    birthday_month: '',
    category: {
      base: 'Category',
      title: 'Category title'
    },
    cover_image: 'Cover photo',
    date: 'Date',
    deleteReason: 'Reason',
    description: 'Description',
    document: {
      title: 'Document title',
      type: 'Resource type'
    },
    emplacement: 'Location',
    employee: {
      name: 'Employee name',
      start_date: 'Start date'
    },
    end_date: 'End date',
    event: {
      description: 'Event description',
      title: 'Event title'
    },
    file: 'File',
    file_url: {
      file: 'File to download/view',
      url: 'Link to the resource'
    },
    icon: 'Icon',
    images: 'Add one or more media files',
    location: 'Location',
    notice: {
      text: 'Notice text',
      title: 'Notice title'
    },
    save: 'Save',
    select_file_multiple: 'Choose one or more files',
    select_file_single: 'Choose a file',
    startDate: 'Start date',
    sub_category: {
      title: 'Subcategory title'
    },
    text: 'Text',
    title: 'Title',
    url: 'URL',
    ofEvent: 'of the event'
  },
  messages: {
    actuality: {
      images: 'The total size of attached documents cannot exceed 5 MB. A maximum of 6 media files per publication.'
    },
    category: {
      choose: 'Choose from existing categories or create a new one.'
    },
    irreversible: 'This action is irreversible.',
    notice: {
      images: 'The total size of attached documents cannot exceed 5 MB. A maximum of 6 media files per notice.'
    },
    reason: 'The notice\'s author will see this information.',
    repeater_links: 'Minimum 1 action and maximum 5 actions.',
    required: '* indicates a required field.',
    url: 'The URL should include the protocol (http://, https://, ...).',
    '500_ko_png_svg': 'Cannot exceed 500 KB. Only .png and .svg formats are accepted.',
    '500_ko_3_1_ratio': 'Cannot exceed 500 KB. A 3:1 ratio is recommended.',
    '5mb_pdf': 'Cannot exceed 5 MB. PDF format is recommended.',
		png_jpg: 'Only .png, .jpg et .jpeg formats are accepted.'
  },
  placeholder: {
    day: 'dd',
    category_id: 'Select a location',
    sub_category: 'Select a type',
    category: 'Select a category',
    month: 'mm',
    birthday: 'Select a day',
    birth_month: 'Select a month',
    name: 'Select an employee or add a new one',
    year: 'yyyy',
    parent_id: 'Select a category',
    type: 'Select a resource type',
    deleteReason: 'Select a reason'
  },
  errors: {
    birthday: 'Please select a day',
    birth_month: 'Please select a month',
    category_id: 'Please choose a location',
		code0: 'The code entered is invalid. Please try again.',
    cover_image: 'Please choose an image',
    date: 'Please enter a valid date',
    deleteReason: 'Please select a reason',
    description: 'Please enter a valid description',
    employee_name: 'Please select an employee or add a new one',
    end_date: 'Please enter a valid end date',
    file: 'Please choose a valid file',
    icon: 'Please choose a valid file',
    icon0: 'Please choose a valid file',
    icon1: 'Please choose a valid file',
    icon2: 'Please choose a valid file',
    icon3: 'Please choose a valid file',
    icon4: 'Please choose a valid file',
    image: 'Please choose a valid file',
    images: 'Please choose up to 6 media files not exceeding 5 MB in total.',
    location: 'Please enter a valid location',
    loginEmail: 'Please enter an email address with the domain odq.qc.ca or farpodq.org',
    parent_id: 'Please choose a category',
    url: 'Please enter a valid URL',
    start_date: 'Please enter a valid start date',
		start_date_employee: 'Please enter a valid start date',
    text: 'Please enter valid text',
    theme: 'Please enter a valid theme',
    title: 'Please enter a valid title',
    type: 'Please choose a valid type'
  },
  reasons: {
    objective: 'The listing has achieved its purpose',
    rules: 'The listing does not comply with the community notice board rules',
    old: 'The listing has expired or is no longer relevant',
    pertinence: 'The listing is not relevant or is off topic',
    false: 'The listing contains incorrect or misleading information',
    double: 'This listing is a duplicate',
    inapropriate: 'The content is inappropriate or offensive'
  }
}
